import BeautyProfileHeading from 'components/Header/BeautyPreferences/BeautyProfileHeading/BeautyProfileHeading';
import { withBeautyProfileHeadingProps } from 'viewModel/header/beautyPreferences/beautyProfileHeading/withBeautyProfileHeadingProps';

export default withBeautyProfileHeadingProps(BeautyProfileHeading);
